'use strict'

var BN = require('bn.js')

module.exports = str2BN

function str2BN(x) {
  return new BN(x)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/big-rat/lib/str-to-bn.js
// module id = pvIz
// module chunks = 0